import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { dismissTeacherAccessWelcome } from '../../utils/dismissTeacherAccessWelcome.js';
import '../../styles/teacherAccessWelcome.big-top.scss';

export default function TeacherAccessWelcomeModal({ show, onHide }) {
  const [dismissing, setDismissing] = useState(false);

  const handleDismiss = async () => {
    if (dismissing) {
      return;
    }

    setDismissing(true);
    try {
      await dismissTeacherAccessWelcome();
      onHide();
    } catch (error) {
      console.error('Failed to dismiss teacher welcome:', error);
      onHide();
    } finally {
      setDismissing(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleDismiss}
      centered
      dialogClassName="teacher-access-welcome--big-top"
    >
      <Modal.Header closeButton={!dismissing}>
        <Modal.Title>Teacher access is ready</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-start">
        <p className="mb-0">
          You can invite students, manage seats, and track class progress from{' '}
          <Link to="/manageClasses" className="teacher-access-welcome__link" onClick={handleDismiss}>
            Manage Classes
          </Link>
          .
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="teacher-access-welcome__actions">
          <Link
            to="/manageClasses"
            className="teacher-access-welcome__btn-next"
            onClick={handleDismiss}
          >
            Manage Classes
          </Link>
          <button
            type="button"
            className="teacher-access-welcome__btn-continue"
            onClick={handleDismiss}
            disabled={dismissing}
          >
            Continue
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
